<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Units",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Pharmacy Item Units",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "units",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "unitName",
          sortable: true,
          label: "UNIT NAME",
        },
        {
          key: "symbol",
          sortable: true,
          label: "UNIT SYMBOL",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingUnit: [],
      nameError: "",
      symbolError: "",

      // Value from user input for adding unit
      data: {
        name: "",
        symbol: "",
      },
      // edit unit
      editdata: {
        new_name: "",
        symbol: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        symbol: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("pharmacy", ["Units", "UnitState"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Units ? this.Units.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Units ? this.Units.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchUnits: "pharmacy/fetchUnits",
      AddUnit: "pharmacy/addUnit",
      EditUnit: "pharmacy/editUnit",
      DeleteUnit: "pharmacy/deleteUnit",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingUnit = this.Units.filter((unit) => {
          return unit.unitName.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingUnit.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingUnit = [];
      }
    },

    addUnit(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Unit name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.symbol === "") {
        this.symbolError = "Unit Symbol field is required";
        return;
      } else {
        this.symbolError = "";
      }
      if (this.existingUnit.length) {
        this.nameError = this.data.name + " exists already please";
        return;
      } else {
        this.nameError = "";
      }

      this.AddUnit(this.data);
    },

    resetAddUnit() {
      this.data.name = "";
      this.data.symbol = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditUnit() {
      this.editdata.new_name = "";
      this.editdata.symbol = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteUnit() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.symbolError = "";
    },
    showEditModal(data) {
      this.editdata.new_name = data.item.unitName;
      this.editdata.symbol = data.item.symbol;
      this.editdata.id = data.item.id;
    },
    editUnit(modalId) {
      this.modal_id = modalId;
      if (this.editdata.new_name === "") {
        this.nameError = "Unit name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.symbol === "") {
        this.symbolError = "Unit Symbol field is required";
        return;
      } else {
        this.symbolError = "";
      }
      this.EditUnit(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.unitName;
      this.deletedata.symbol = data.item.symbol;
      this.deletedata.id = data.item.id;
    },
    deleteUnit(modalId) {
      this.modal_id = modalId;
      this.DeleteUnit(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchUnits();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>
                  <b-button v-if="user_permissions.add_units" class="float-end" variant="primary" v-b-modal.add-unit-modal
                    ><i class="fa fa-plus"></i> Add Unit</b-button
                  >

                  <!-- modal starts -->
                  <b-modal id="add-unit-modal" hide-footer @hidden="resetAddUnit">
                    <template #modal-title> Add New Unit </template>
                    <div class="form-group mb-3">
                      <label>Unit Name</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Unit Name"
                          class="form-control"
                          @keyup="checkName"
                          @input="resetError"
                          v-model="data.name"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Unit Symbol</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Unit Symbol"
                          class="form-control"
                          @input="resetError"
                          v-model="data.symbol"
                        />
                      </div>
                      <div class="text-danger" v-if="symbolError">
                        <em>{{ symbolError }}</em>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        data-dismiss="modal"
                        @click="closeModal('add-unit-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addUnit('add-unit-modal')"
                      >
                        <i class="fa fa-check"></i>
                        Submit
                        <b-spinner
                          v-if="UnitState"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Units ? Units : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button v-if="user_permissions.edit_units"
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-unit-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-else
                  disabled
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-unit-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button v-if="user_permissions.delete_units"
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-unit-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                  <b-button v-else
                  disabled
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-unit-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!Units" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-unit-modal" hide-footer @hidden="resetEditUnit">
              <template #modal-title> Edit Unit {{ editdata.new_name }}</template>
              <div class="form-group mb-3">
                <label>Unit Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.new_name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Unit Symbol</label>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    @input="resetError"
                    v-model="editdata.symbol"
                  />
                </div>
                <div class="text-danger" v-if="symbolError">
                  <em>{{ symbolError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-unit-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="editUnit('edit-unit-modal')"
                >
                  <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="UnitState"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete unit starts -->
            <b-modal id="delete-unit-modal" hide-footer @hidden="resetDeleteUnit">
              <template #modal-title>
                <h4 class="text-danger">Delete Unit {{ deletedata.name }}</h4></template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this unit? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-unit-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="deleteUnit('delete-unit-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="UnitState"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
